// Router tracking is disabled — only XHR-level distributed tracing is active.
// These exports are kept as no-ops for backward compatibility with telemetry.run.js.

export const startPageSpan = (_routeName: string, _params?: Record<string, unknown>): void => {};
export const markPageLoaded = (): void => {};
export const prepareTabbedPage = (_routeName: string): void => {};
export const setPageTab = (_tabName: string, _tabId?: string): void => {};
export const endPageSpan = (_error?: Error): void => {};
export const getPageContext = () => {
  // Return undefined so the XHR.send wrapper falls back to context.active()
  return undefined as any;
};
export const getActivePageSpan = () => null;